// @ts-nocheck
(() => {
  const ROOT_SELECTOR = '.c-delivery-purchase-form';

  function getErrorTarget(element) {
    const inputGroup = element.closest('.c-delivery-purchase-form__input-group');
    if (inputGroup) return inputGroup;
    return element;
  }

  function getFieldErrorId(element) {
    return `${element.id || element.name}-field-error`;
  }

  function showFieldError(element, message) {
    if (!element) return;

    const errorId = getFieldErrorId(element);
    const target = getErrorTarget(element);

    let errorElement = document.getElementById(errorId);

    if (!errorElement) {
      errorElement = document.createElement('p');
      errorElement.id = errorId;
      errorElement.className = 'c-delivery-purchase-form__field-error';
      errorElement.hidden = true;
      target.insertAdjacentElement('afterend', errorElement);
    }

    errorElement.textContent = message;
    errorElement.hidden = false;
    element.setAttribute('aria-invalid', 'true');
    element.setAttribute('aria-describedby', errorId);
  }

  function clearFieldError(element) {
    if (!element) return;

    const errorId = getFieldErrorId(element);
    const errorElement = document.getElementById(errorId);

    if (errorElement) {
      errorElement.textContent = '';
      errorElement.hidden = true;
    }

    element.removeAttribute('aria-invalid');
    element.removeAttribute('aria-describedby');
  }

  function validateRequiredField(element, message) {
    if (!element || element.disabled || !element.required) return true;

    if (element.value.trim() === '') {
      showFieldError(element, message);
      return false;
    }

    clearFieldError(element);
    return true;
  }

  function validateEmailField(element) {
    if (!element || element.disabled || !element.required) return true;

    if (element.value.trim() === '') {
      showFieldError(element, 'メールアドレスをご入力ください。');
      return false;
    }

    if (!element.checkValidity()) {
      showFieldError(element, 'メールアドレスの形式をご確認ください。');
      return false;
    }

    clearFieldError(element);
    return true;
  }

  function validatePhoneField(element) {
    if (!element || element.disabled || !element.required) return true;

    if (element.value.trim() === '') {
      showFieldError(element, '電話番号をご入力ください。');
      return false;
    }

    if (!/^[0-9-]+$/.test(element.value.trim())) {
      showFieldError(element, '電話番号は半角数字とハイフンで入力してください。');
      return false;
    }

    clearFieldError(element);
    return true;
  }

  function initContactForm(root) {
    if (!root || root.dataset.contactFormInitialized === 'true') return;

    const formElement = root.querySelector('form');
    if (!formElement) return;

    root.dataset.contactFormInitialized = 'true';
    formElement.noValidate = true;

    const lastNameInput = formElement.elements['contact[お名前（姓）]'];
    const firstNameInput = formElement.elements['contact[お名前（名）]'];
    const lastNameKanaInput = formElement.elements['contact[フリガナ（セイ）]'];
    const firstNameKanaInput = formElement.elements['contact[フリガナ（メイ）]'];
    const phoneInput = formElement.elements['contact[電話番号]'];
    const emailInput = formElement.elements['contact[email]'];
    const bodyInput = formElement.elements['contact[お問い合わせ内容]'];

    function validateForm() {
      let firstInvalidElement = null;

      function validateField(callback, focusElement) {
        const isValid = callback();

        if (!isValid && !firstInvalidElement) {
          firstInvalidElement = focusElement;
        }

        return isValid;
      }

      const isValid = [
        validateField(() => validateRequiredField(lastNameInput, 'お名前（姓）をご入力ください。'), lastNameInput),
        validateField(() => validateRequiredField(firstNameInput, 'お名前（名）をご入力ください。'), firstNameInput),
        validateField(() => validateRequiredField(lastNameKanaInput, 'フリガナ（セイ）をご入力ください。'), lastNameKanaInput),
        validateField(() => validateRequiredField(firstNameKanaInput, 'フリガナ（メイ）をご入力ください。'), firstNameKanaInput),
        validateField(() => validatePhoneField(phoneInput), phoneInput),
        validateField(() => validateEmailField(emailInput), emailInput),
        validateField(() => validateRequiredField(bodyInput, 'お問い合わせ内容をご入力ください。'), bodyInput),
      ].every(Boolean);

      if (!isValid && firstInvalidElement) {
        firstInvalidElement.focus();
      }

      return isValid;
    }

    function stopInvalidSubmit(event) {
      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      return false;
    }

    formElement.addEventListener('submit', (event) => {
      if (!validateForm()) {
        return stopInvalidSubmit(event);
      }

      return true;
    }, true);

    [
      [lastNameInput, () => validateRequiredField(lastNameInput, 'お名前（姓）をご入力ください。')],
      [firstNameInput, () => validateRequiredField(firstNameInput, 'お名前（名）をご入力ください。')],
      [lastNameKanaInput, () => validateRequiredField(lastNameKanaInput, 'フリガナ（セイ）をご入力ください。')],
      [firstNameKanaInput, () => validateRequiredField(firstNameKanaInput, 'フリガナ（メイ）をご入力ください。')],
      [phoneInput, () => validatePhoneField(phoneInput)],
      [emailInput, () => validateEmailField(emailInput)],
      [bodyInput, () => validateRequiredField(bodyInput, 'お問い合わせ内容をご入力ください。')],
    ].forEach(([element, callback]) => {
      if (!element) return;

      element.addEventListener('input', () => {
        if (element.getAttribute('aria-invalid') === 'true') {
          callback();
        }
      });
    });
  }

  function initAll(scope) {
    const targetScope = scope || document;
    targetScope.querySelectorAll(ROOT_SELECTOR).forEach(initContactForm);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  initAll(document);
})();